import {
  OfflineCurrentCustomerMetadata,
  OfflineTaskType,
} from '@zonofi/zono-money-store';
import React, { useMemo } from 'react';
import './sync-activity-card.scss';
import { Avatar } from '../components';
import { SyncTaskItemCard, TaskItem } from './sync-task-item-card';

export interface SyncActivityCustomerCardProps {
  customer: OfflineCurrentCustomerMetadata;
  tasks: TaskItem[];
}

export const SyncActivityCustomerCard: React.FC<
  SyncActivityCustomerCardProps
> = ({ customer, tasks }) => {
  const displayTasks: (TaskItem | TaskItem[])[] = useMemo(() => {
    let temp: (TaskItem | TaskItem[])[] = [];
    tasks.forEach((task) => {
      if (
        [OfflineTaskType.CHECK_IN, OfflineTaskType.CHECK_OUT].includes(
          task.type
        )
      )
        temp.push(task);
      else {
        const lastItem = temp[temp.length - 1];
        if (Array.isArray(lastItem)) {
          lastItem.push(task);
        } else {
          temp.push([task]);
        }
      }
    });
    return temp;
  }, [tasks]);

  return (
    <div className="sync-activity-customer">
      <div className="customer-header">
        <Avatar id={customer.customerId} title={customer.customerName} />
        <div>
          <div className="customer-header-name font-semibold">
            {customer.customerName}
          </div>
          <div className="customer-header-phone font-regular">
            {`+${customer.phone}`}
          </div>
        </div>
      </div>
      <div className="task-container">
        {displayTasks.map((task, index) => (
          <SyncTaskItemCard key={index} task={task} customer={customer} />
        ))}
      </div>
    </div>
  );
};
